import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import Loading from "@/components/home/Loading";
import Alert from "@/components/scan/parts/Alert.vue";
import { ref, onMounted } from "vue";
import { useI18n } from "vue3-i18n";
import { store } from "@/store/store";
import ResponseData from "@/types/ResponseData";
import GroupAdminService from "@/services/GroupAdminService";
import UserInfoDataService from "@/services/UserInfoDataService";
import UserListDataService from "@/services/UserListDataService";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const pageTitle = ref(store.getters.showPageTitle);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const userId = ref("");
const empNumber = ref("");
const givenName = ref("");
const familyName = ref("");
const email = ref("");
const groupId = ref("");
const flgType = ref("");

const userIdError = ref("");
const empNumberError = ref("");
const givenNameError = ref("");
const familyNameError = ref("");
const emailError = ref("");
const groupIdError = ref("");

const beforeChangeFName = ref("");
const beforeChangeGName = ref("");

/** 初期表示設定 */
onMounted(function () {
  isLoading.value = false;
  flgType.value ="";
  userId.value = store.getters.groupUserId;
  empNumber.value = store.getters.groupUserId;
  givenName.value = store.getters.groupLName;
  familyName.value = store.getters.groupFName;
  email.value = store.getters.groupEmail;
  groupId.value = store.getters.group;
  if (pageTitle.value =="Edit Group Admin"){
    flgType.value ="Edit";
  }
 
  
});

const backbtn = () => {
  store.dispatch("setShowPage", "groupAdmin");
  store.dispatch("setShowPageTitle", "Group Admin List");
};

const getEditUserInfo = (event: { target: { value: any; }; }) => {
  var userId = event.target.value;
  const param = {
    userId: userId,
    loginUserId: store.getters.cognitoUserName
  };
  empNumber.value = '';
  givenName.value = '';
  familyName.value = '';
  email.value = '';
  UserListDataService.getUserInformation(param)
  .then((response: ResponseData) => {
    if (response.data.userObjList.length > 0) {
        console.log(response.data);
        var info = response.data.userObjList[0];
        empNumber.value = info.employeeNumber;
        givenName.value = info.givenName;
        familyName.value = info.familyName;
        email.value = info.email;
    }
    isLoading.value = false;
  })
  .catch((e: Error) => {
    console.log(e);
    alertMessage.value = i18n.t("err012");
    alertState.value = "error";
    isLoading.value = false;
  });
}

const validUserID = (userID, authenticateFlg) => {
  var re1 = /^[A-Za-z0-9]+$/;
  var re2 = /^[0-9]+$/;
  var result = false;
  if (authenticateFlg) {
    result =
      re1.test(userID) &&
      re1.test(userID.substr(0, 2)) &&
      re2.test(userID.substr(2)) &&
      userID.length == 6;
  } else {
    result = re1.test(userID);
  }
  return result;
};
const checkSpecialCharacter = (userName) => {
  var re = /[`!@#$%^&*()_+\-={};':"\\|,.<>/?＿~]/;
  return re.test(userName);
};
const validEmail = (email) => {
  var re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};


// [Add]ボタン押す
const AddUpdateGroup = (flg) => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  flgType.value = flg;
  // フォーマットと空白チェックフラグ
  var inputChek = true;
  
  //[Group]のチェック
  if(groupId.value.trim() ==""){
    groupIdError.value = i18n.t("alt073");
    inputChek = false;
  }else if(checkSpecialCharacter(groupId.value)) {
      groupIdError.value = i18n.t("alt019");
      inputChek = false;
} else {
      groupIdError.value = "";
}

  //[User ID]のチェック
  if (userId.value.trim() == "") {
    userIdError.value = i18n.t("alt067");
    inputChek = false;
  } else if (!validUserID(userId.value.trim(), true)) {
    userIdError.value = i18n.t("alt068");
    inputChek = false;
  } else {
    userIdError.value = "";
  }

  //[Employee Number]のチェック
  if (empNumber.value.trim() == "") {
    empNumberError.value = i18n.t("alt012");
    inputChek = false;
  } else if (!validUserID(empNumber.value.trim(), false)) {
    empNumberError.value = i18n.t("alt013");
    inputChek = false;
  } else {
    empNumberError.value = "";
  }

  //[Given Name]のチェック
  if (givenName.value.trim() == "") {
    givenNameError.value = i18n.t("alt015");
    inputChek = false;
  } else if (checkSpecialCharacter(givenName.value.trim())) {
    givenNameError.value = i18n.t("alt016");
    inputChek = false;
  } else {
    givenNameError.value = "";
  }

  //[Family Name]のチェック
  if (familyName.value.trim() == "") {
    familyNameError.value = i18n.t("alt017");
    inputChek = false;
  } else if (checkSpecialCharacter(familyName.value.trim())) {
    familyNameError.value = i18n.t("alt018");
    inputChek = false;
  } else {
    familyNameError.value = "";
  }

  //[E-mail]のチェック
  if (email.value.trim() == "") {
    emailError.value = i18n.t("alt021");
    inputChek = false;
  } else if (!validEmail(email.value)) {
    emailError.value = i18n.t("alt022");
    inputChek = false;
  } else {
    emailError.value = "";
  }

  var dbDataCheckFlg = true;
  var dataCheck = true;
  // User ID重複チェックを行う
  const data = { groupId: groupId.value };
  const upData = {
    group: groupId.value,
    managerMail: email.value,
  };
  GroupAdminService.getGroupIDInfo(data)
    .then((response: ResponseData) => {
      if (response.data.length != 0 && flg == "Add") {
        //課がPermissionGroupにある
        groupIdError.value = i18n.t("alt074");
        dbDataCheckFlg = false;
      }else if(response.data.length == 0 || flg == "Edit") {
      // Employee Numberと Station Code重複チェックを行う
      const data = { userId: userId.value, stationCode: "1000" };
      UserInfoDataService.getEmployeeStationDuplicateInfo(data)
        .then((response: ResponseData) => {
          if (response.data.length != 0 && inputChek) {
            //ユーザが存在している
            if(response.data[0].userId == userId.value){
                isLoading.value = false;
            }
            if(response.data[0].employeeNumber == empNumber.value){
                isLoading.value = false;
            }else{
                empNumberError.value = i18n.t("alt075");
                dataCheck= false;
            }
            if(response.data[0].givenName == givenName.value){
                isLoading.value = false;
            }else{
                givenNameError.value = i18n.t("alt076");
                dataCheck= false;
            }
            if(response.data[0].familyName == familyName.value){
                isLoading.value = false;
            }else{
                familyNameError.value = i18n.t("alt077");
                dataCheck= false;
            }
            if(response.data[0].email == email.value){
                isLoading.value = false;
            }else{
                emailError.value = i18n.t("alt078");
                dataCheck= false;
            }
            if (dataCheck){
              if (flg == "Add"){
                //課がPermissionGroupにないのでテーブルに追加
                insertGroupInfo();
              }else if(flg == "Edit")
              {
                updateGroupInfo();
                deleteMenu();
              }
            
            //MenuApproval画面権限追加
            insertMenu();
            }
            //GroupAdminに対象課の課長のメールアドレスを更新
            //GroupAdminService.updateGroupAdmin(upData)
          }else{
            if (inputChek){
             //ユーザが存在していない
             if(flg == "Add"){
             //課がPermissionGroupにないのでテーブルに追加
              insertGroupInfo();
             }else if(flg == "Edit")
              {
                updateGroupInfo();
                deleteMenu();
              }
             
            // StationCodeチェックを行う
            const data = {
              stationCode: "1000",
              companyName: "",
              threeDigit: "",
            };
            UserInfoDataService.getStationInfo(data)
              .then((response: ResponseData) => {
                if (response.data.length != 0 ) {
                  var strCompName = "";
                  for (let info2 of response.data) {
                    strCompName = info2.companyName;
                  }
                  const groupadminData ={
                    actionFlg: 5,
                    userID: userId.value,
                    LName: familyName.value,
                    FName: givenName.value,
                    employeeID: empNumber.value,
                    mail: email.value,
                    companyName: strCompName,
                    stationCode: "1000",
                  };
                  UserInfoDataService.send_authenticationID(groupadminData)
                  .then((response: ResponseData) => {
                    insertGroupAdminInfo();
                  })
                  .catch((e: Error) => {
                    alertMessage.value = i18n.t("err018");
                    alertState.value = "error";
                    isLoading.value = false;
                  });

                }
              })
            .catch((e: Error) => {
              alertMessage.value = i18n.t("err018");
              alertState.value = "error";
              isLoading.value = false;
            });

          }
        }
        })
        .catch((e: Error) => {
          alertMessage.value = i18n.t("err020");
          alertState.value = "error";
          isLoading.value = false;
        });
      }
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err071");
      alertState.value = "error";
      isLoading.value = false;
    });

};

const insertGroupAdminInfo = () => {
  const userinfoData = {
    userId: userId.value,
    givenName: givenName.value,
    familyName: familyName.value,
    email: email.value,
    department: groupId.value,
    title: "",
    stationCode: "1000",
    mainMenuCode: [],
  };
  UserInfoDataService.insertUserInfo(userinfoData)
  .then((response: ResponseData) => {
    insertMenu();
  })
  .catch((e: Error) => {
      alertMessage.value = i18n.t("err016");
      alertState.value = "error";
      isLoading.value = false;
    });
};

const insertMenu = () => {
    const pdata = { userId: userId.value };
    GroupAdminService.insertMenuApproval(pdata)
    .then((response: ResponseData) => {
      if(flgType.value == "Add"){
        alertMessage.value = i18n.t("suc035");
      }else if(flgType.value == "Edit"){
        alertMessage.value = i18n.t("suc036");
      }
      alertState.value = "success";
      isLoading.value = false;
    })
    .catch((e: Error) => {
        alertMessage.value = i18n.t("err017");
        alertState.value = "error";
        isLoading.value = false;
      });
    };

const insertGroupInfo = () => {
  const gdata = {
    group: groupId.value,
    managerMail: email.value,
  };
  GroupAdminService.insertGroup(gdata)
  .then((response: ResponseData) => {
    isLoading.value = false;
  })
  .catch((e: Error) => {
      alertMessage.value = i18n.t("err072");
      alertState.value = "error";
      isLoading.value = false;
    });

};

const updateGroupInfo = () => {
  const updata = {
    group: groupId.value,
    managerMail: email.value,
  };
  GroupAdminService.updateGroup(updata)
  .then((response: ResponseData) => {
    isLoading.value = false;
  })
  .catch((e: Error) => {
      alertMessage.value = i18n.t("err073");
      alertState.value = "error";
      isLoading.value = false;
    });

};

const deleteMenu = () => {
  const Mdata = {
    userId: store.getters.groupUserId };
  GroupAdminService.deleteMenuApproval(Mdata)
  .then((response: ResponseData) => {
    isLoading.value = false;
  })
  .catch((e: Error) => {
      alertMessage.value = i18n.t("err059");
      alertState.value = "error";
      isLoading.value = false;
    });

};

const txtOnKeyDown = (event: { target: { value: any; }; }) => {
  var re = /^[A-Za-z ]+$/;
  beforeChangeFName.value = re.test(familyName.value)? familyName.value: beforeChangeFName.value;
  beforeChangeGName.value = re.test(givenName.value)? givenName.value: beforeChangeGName.value;
}
const checkAlphabet = (event: { target: { value: any; }; }) => {
  var re = /^[A-Za-z ]+$/;
  if(!re.test(event.target.value) && event.target.value != ""){
    familyName.value = beforeChangeFName.value;
    givenName.value = beforeChangeGName.value;
  }
  return;
}


const __returned__ = { isLoading, pageTitle, alertMessage, alertState, i18n, userId, empNumber, givenName, familyName, email, groupId, flgType, userIdError, empNumberError, givenNameError, familyNameError, emailError, groupIdError, beforeChangeFName, beforeChangeGName, backbtn, getEditUserInfo, validUserID, checkSpecialCharacter, validEmail, AddUpdateGroup, insertGroupAdminInfo, insertMenu, insertGroupInfo, updateGroupInfo, deleteMenu, txtOnKeyDown, checkAlphabet, AdminNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})